import {
	Box,
	H1,
	HStack,
	Tab,
	TabPanel,
	TabPanels,
	Tabs,
	Text,
	VStack,
} from '@montel/montelpro-shared-components-v2';
import { useGlobalContext } from 'components/common/GlobalContext/GlobalContext';
import { FunctionComponent, useEffect, useState } from 'react';
import { Area } from './Area';
import { geoNodeSort } from 'utils/geoNodeHelpers';

const PermissionsOverview: FunctionComponent = () => {
	const { permissionOptions } = useGlobalContext();
	const [activeTab, setActiveTab] = useState('');

	useEffect(
		() => setActiveTab(permissionOptions[0]?.applicationId || ''),
		[permissionOptions],
	);

	return (
		<Box bg="bgMainContainer">
			<VStack justify="center" fullWidth gap="xl">
				<H1>Permissions overview</H1>
				<Tabs activeTab={activeTab} setActiveTab={setActiveTab}>
					{permissionOptions.map((option) => (
						<Tab
							key={option.applicationId}
							value={option.applicationId}
							label={option.applicationName}
						/>
					))}
				</Tabs>
				<TabPanels currentTab={activeTab}>
					{permissionOptions.map((option) => (
						<TabPanel
							key={option.applicationId}
							name={option.applicationId}
						>
							<HStack gap="10xl">
								<VStack>
									<Text color="textSubtle">Plans</Text>
									{option.plans.map((plan) => (
										<HStack key={plan.code}>
											{plan.displayName}
											<Text color="textSubtle">
												({plan.code})
											</Text>
										</HStack>
									))}
								</VStack>

								<VStack>
									<Text color="textSubtle">Addons</Text>
									{option.addons?.length ? (
										option.addons.map((addon) => (
											<HStack key={addon.code}>
												{addon.name}
												<Text color="textSubtle">
													({addon.code})
												</Text>
											</HStack>
										))
									) : (
										<>-</>
									)}
								</VStack>
								<VStack>
									<Text color="textSubtle">Areas</Text>
									{option.areas?.length ? (
										option.areas
											.sort(geoNodeSort)
											.map((area) => (
												<Area
													key={area.code}
													area={area}
												/>
											))
									) : (
										<>-</>
									)}
								</VStack>
							</HStack>
						</TabPanel>
					))}
				</TabPanels>
			</VStack>
		</Box>
	);
};

export default PermissionsOverview;
